import { css } from '@/styled-system/css';

export const upsellBannerCloseButtonStyles = css.raw({
  lgDown: {
    position: 'absolute',
    insetBlockStart: 'UpsellBanner.CloseButton.margin.top',
    insetInlineEnd: 'UpsellBanner.CloseButton.margin.right',
  },
  lg: {
    marginInlineStart: 'auto',
    flexShrink: 0,
  },
});
